const symbols = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export const generateId = (length = 10) =>
  Array.from({length}, () => symbols
    .charAt(Math.floor(Math.random() * 62)))
    .join('');
